<template>
  <div class="auth-wrapper">
    <div class="background-image"></div>
    <div class="background-overlay"></div>

    <transition name="fade-slide" mode="out-in">
      <div class="form-container translucent" :key="modo">
        <template v-if="modo === 'otp'">
          <h2 class="title">Verificación</h2>
          <p class="otp-msg">
            Se envió un código a
            <strong class="correo-verde">{{ form.correo }}</strong
            >. Revisa tu correo, puede tardar hasta 5 minutos en llegar.
          </p>
          <div class="otp-inputs">
            <input
              v-for="(d, i) in otp"
              :key="i"
              ref="otpInput"
              v-model="otp[i]"
              maxlength="1"
              pattern="[0-9]*"
              inputmode="numeric"
              @input="focusNext(i)"
            />
          </div>
          <div class="otp-actions">
            <a @click.prevent="editarCorreo" :disabled="contador > 0"
              >Editar correo</a
            >
            |
            <a @click.prevent="reenviarOtp" :disabled="contador > 0"
              >Reenviar</a
            >
            <span v-if="contador > 0"> ({{ contador }})</span>
          </div>
          <div class="buttons has-text-centered mt-4">
            <b-button
              id="verde"
              type="is-primary"
              rounded
              :disabled="otp.join('').length !== 4"
              @click="confirmarOtp"
              >Confirmar</b-button
            >
          </div>
          <div class="switch-mode">
            <a @click.prevent="irLogin">¿Ya tienes cuenta? Inicia sesión</a>
          </div>
        </template>
        <template v-else>
          <h2 class="title">{{ modo === "login" ? "Inicio" : "Registrar" }}</h2>

          <b-field class="input-field">
            <b-input
              v-model="form.correo"
              placeholder="correo"
              icon="account"
            />
          </b-field>

          <b-field class="input-field">
            <b-input
              v-model="form.password"
              type="text"
              placeholder="Contraseña"
              icon="lock"
            />
          </b-field>

          <template v-if="modo === 'register'">
            <b-field class="input-field">
              <b-input
                v-model="form.confirmPassword"
                type="password"
                placeholder="Confirmar contraseña"
                icon="lock"
                :class="{ 'is-success': passwordMatch }"
              />
            </b-field>
            <b-field class="input-field">
              <b-input
                v-model="form.nombre"
                placeholder="Nombre"
                icon="account"
              />
            </b-field>
            <b-field class="input-field">
              <b-input
                v-model="form.telefono"
                placeholder="Teléfono"
                icon="phone"
              />
            </b-field>

            <b-field class="checkbox-field">
              <b-checkbox v-model="acceptedTerms">
                Acepto los
                <a href="#" @click.prevent="mostrarPolitica"
                  >términos y condiciones</a
                >
              </b-checkbox>
              <p class="terms-desc">
                Tus datos se usarán exclusivamente con fines estadísticos y de
                contacto para métricas internas, conforme a la Ley 1581/2012
                (Habeas Data) y GDPR.
              </p>
            </b-field>
          </template>

          <div class="buttons has-text-centered mt-4">
            <b-button
              id="verde"
              type="is-primary"
              rounded
              :disabled="modo === 'register' && !acceptedTerms"
              @click="submit"
            >
              {{ modo === "login" ? "Inicio" : "Registrar" }}
            </b-button>
          </div>

          <div class="switch-mode">
            <a @click.prevent="toggleModo">
              {{
                modo === "login"
                  ? "¿No tienes cuenta? Regístrate"
                  : "¿Ya tienes cuenta? Inicia sesión"
              }}
            </a>
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";

export default {
  name: "LoginPrincipal",
  data() {
    return {
      modo: "login",
      form: {
        correo: "",
        password: "",
        confirmPassword: "",
        nombre: "",
        telefono: "",
      },
      acceptedTerms: false,
      idUsuario: null,
      otp: ["", "", "", ""],
      contador: 0,
      temporizador: null,
    };
  },
  mounted() {
    const correo = localStorage.getItem("correo");
    const validado = localStorage.getItem("validado");
    if (!correo) {
      localStorage.setItem("validado", "1");
    } else if (validado === "1") {
      this.$router.push({ name: "InicioUsuario" });
    } else {
      this.form.correo = correo;
    }
  },
  computed: {
    passwordMatch() {
      return (
        this.modo === "register" &&
        this.form.confirmPassword &&
        this.form.confirmPassword === this.form.password
      );
    },
  },
  methods: {
    toggleModo() {
      this.modo = this.modo === "login" ? "register" : "login";
      this.acceptedTerms = false;
      this.form.nombre = "";
      this.form.telefono = "";
      this.form.confirmPassword = "";
    },
    async submit() {
      if (!this.form.correo) {
        this.$buefy.toast.open({
          message: "El correo es obligatorio.",
          type: "is-danger",
        });
        return;
      }
      if (!this.form.password) {
        this.$buefy.toast.open({
          message: "La contraseña es obligatoria.",
          type: "is-danger",
        });
        return;
      }
      if (this.modo === "register") {
        if (!this.form.confirmPassword) {
          this.$buefy.toast.open({
            message: "Debes confirmar la contraseña.",
            type: "is-danger",
          });
          return;
        }
        if (!this.form.nombre) {
          this.$buefy.toast.open({
            message: "El nombre es obligatorio.",
            type: "is-danger",
          });
          return;
        }
        if (!this.form.telefono) {
          this.$buefy.toast.open({
            message: "El teléfono es obligatorio.",
            type: "is-danger",
          });
          return;
        }
      }
      if (this.modo === "register") {
        const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const telefonoRegex = /^3\d{9}$/;
        if (!correoRegex.test(this.form.correo)) {
          this.$buefy.toast.open({
            message: "Ingresa un correo válido.",
            type: "is-danger",
          });
          return;
        }
      
        if (!telefonoRegex.test(this.form.telefono)) {
          this.$buefy.toast.open({
            message: "El teléfono debe iniciar con 3 y tener 10 dígitos.",
            type: "is-danger",
          });
          return;
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.$buefy.toast.open({
            message: "Las contraseñas no coinciden.",
            type: "is-danger",
          });
          return;
        }
      }
      if (this.modo === "register" && !this.acceptedTerms) {
        this.$buefy.toast.open({
          message: "Debes aceptar los términos y condiciones.",
          type: "is-warning",
        });
        return;
      }

      /* ---------------- REGISTRO ---------------- */
      if (this.modo === "register") {
        // 1. ¿El correo ya existe?
        const existe = await HttpService.registrar("usuarios.php", {
          accion: "validarCorreo",
          correo: this.form.correo,
        });

        if (existe && existe.registrado) {
          this.$buefy.toast.open({
            message: "Este correo ya está registrado.",
            type: "is-warning",
          });
          return;
        }

        // 2. Registrar usuario y obtener ID
        const reg = await HttpService.registrar("usuarios.php", {
          accion: "registrar",
          correo: this.form.correo,
          clave: this.form.password,
          nombre: this.form.nombre,
          telefono: this.form.telefono,
        });

        if (!reg || !reg.ok) {
          this.$buefy.toast.open({
            message: "No se pudo registrar.",
            type: "is-danger",
          });
          return;
        }

        this.idUsuario = reg.idUsuario;

        // 3. Enviar OTP vía n8n
        const otpResp = await fetch("https://n8n.megapos.co/webhook/otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idUsuario: this.idUsuario,
            correo: this.form.correo,
          }),
        });

        const respJson = await otpResp.json().catch(() => ({}));

        if (otpResp.ok && respJson.message === "Workflow was started") {
          this.$buefy.toast.open({
            message: "Se envió un código de verificación a tu correo.",
            type: "is-success",
          });
          this.modo = "otp";
          this.iniciarConteo();
        } else {
          this.$buefy.toast.open({
            message: "No se pudo enviar el código OTP.",
            type: "is-danger",
          });
        }
        return; // finaliza flujo de registro
      }

      /* ---------------- LOGIN (sin OTP) ---------------- */
      try {
        const loginRes = await HttpService.registrar("usuarios.php", {
          accion: "login",
          correo: this.form.correo,
          clave: this.form.password,
        });

        if (loginRes.ok) {
          localStorage.setItem("correo", this.form.correo);
          localStorage.setItem("idUsuario", loginRes.idUsuario);
          localStorage.setItem("validado", "1");
          this.$buefy.toast.open({
            message: "Bienvenido 🎉",
            type: "is-success",
          });
          this.$router.push({ name: "InicioUsuario" });
        } else {
          this.$buefy.toast.open({
            message: loginRes.mensaje || "Credenciales incorrectas.",
            type: "is-danger",
          });
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: "Error del servidor: " + err.message,
          type: "is-danger",
        });
      }
    },
    focusNext(index) {
      if (this.otp[index] && index < 3) {
        this.$refs.otpInput[index + 1].focus();
      }
    },
    iniciarConteo() {
      this.contador = 60;
      clearInterval(this.temporizador);
      this.temporizador = setInterval(() => {
        if (this.contador > 0) this.contador--;
        else clearInterval(this.temporizador);
      }, 1000);
    },
    async reenviarOtp() {
      if (this.contador > 0) return;
      const otpResp = await fetch("https://n8n.megapos.co/webhook/otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idUsuario: this.idUsuario,
          correo: this.form.correo,
        }),
      });
      if (otpResp.ok) {
        this.$buefy.toast.open({
          message: "OTP reenviado",
          type: "is-success",
        });
        this.iniciarConteo();
      } else {
        this.$buefy.toast.open({
          message: "Error al reenviar",
          type: "is-danger",
        });
      }
    },
    editarCorreo() {
      if (this.contador > 0) return;
      this.modo = "register";
      this.otp = ["", "", "", ""];
    },
    irLogin() {
      this.modo = "login";
      this.otp = ["", "", "", ""];
      clearInterval(this.temporizador);
      this.contador = 0;
      this.form.confirmPassword = "";
    },
    async confirmarOtp() {
      const codigo = this.otp.join("");
      const resp = await HttpService.registrar("otp.php", {
        accion: "validar",
        idUsuario: this.idUsuario,
        codigo,
      });
      if (resp.ok) {
        this.$buefy.toast.open({
          message: "Registro completado",
          type: "is-success",
        });
        this.modo = "login";
        this.form.password = "";
        this.form.confirmPassword = "";
      } else {
        this.$buefy.toast.open({
          message: resp.mensaje || "OTP inválido",
          type: "is-danger",
        });
      }
    },
    mostrarPolitica() {
      this.$buefy.dialog.alert({
        title: "Términos y condiciones",
        message: `Tus datos personales se almacenarán de manera segura y se utilizarán exclusivamente con finalidades estadísticas, de contacto y métricas internas de Metropolitan Food, sin ser compartidos con terceros no autorizados. Puedes ejercer tus derechos de acceso, rectificación y eliminación en cualquier momento conforme a la Ley 1581/2012 y GDPR.`,
        type: "is-info",
        hasModalCard: true,
      });
    },
  },
};
</script>


<style scoped>
.auth-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: #000;
}
.background-image {
  background-image: url("https://megapos.co/fotos/6857c48c7cf83.webp");
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 0;
}
.form-container.translucent {
  background: rgba(0, 0, 0, 0.65);
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  padding: 2rem 1.75rem;
  width: 100%;
  max-width: 360px;
  z-index: 1;
  color: white;
}
.title {
  text-align: center;
  font-size: 1.9rem;
  margin-bottom: 1.5rem;
  color: white;
}
.input-field {
  margin-bottom: 1rem;
}
.checkbox-field {
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}
.terms-desc {
  font-size: 0.72rem;
  color: #ccc;
  margin-top: 4px;
  line-height: 1.25;
}
.switch-mode {
  text-align: center;
  margin-top: 1.3rem;
  font-weight: 500;
}
.switch-mode a {
  color: #ffffff;
  cursor: pointer;
  text-decoration: underline;
  opacity: 0.8;
}
.decor-img {
  position: absolute;
  width: 110px;
  opacity: 0.85;
  z-index: 0;
}
.top-left {
  top: 2px;
  left: -30px;
}
.bottom-right {
  bottom: 80px;
  right: 0;
  transform: scaleX(-1);
}
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.35s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
#verde {
  background-color: #85ade9 !important;
}
.correo-verde {
  color: #8fbc8f;
}
.otp-inputs {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 16px 0;
}
.otp-inputs input {
  width: 3rem;
  height: 3rem;
  text-align: center;
  font-size: 1.5rem;
}
.otp-actions {
  text-align: center;
  margin-bottom: 1rem;
}
</style>
